import { types } from 'mobx-state-tree'

export default types.model({
  material: '',
  materialId: types.maybe(types.string),
  units: '',
  unitCost: 0,
  isUnitCostEdited: false,
  unitsRequired: 0,
  isUnitsRequiredEdited: false,
  lengthsRequired: 0
}).views(self => ({
  extendedCost() {
    return self.unitsRequired * self.unitCost
  }
})).actions(self => ({
  setUnitsRequired(value) {
    self.unitsRequired = value
    self.isUnitsRequiredEdited = true
    self.lengthsRequired = 0
  }
}))


// WEBPACK FOOTER //
// ./src/models/CalculatedMaterialRequirement.js